import { getRepositoryCustomTypes } from "@prismicio/editor-fields"
import { getRequestCredentials, request } from "@prismicio/editor-support/Http"
import { useRequest } from "@prismicio/editor-support/Suspense"
import { StaticCustomType } from "@prismicio/types-internal/lib/customtypes"
import { z } from "zod"

import { env } from "../env"
import { getRepositoryName } from "../routing"

export function getCustomType(id: string) {
  const url = new URL(`customtypes/${id}`, env.CUSTOM_TYPES_API_BASE_URL)
  url.searchParams.set("static", "true")

  return request(url, {
    headers: {
      repository: getRepositoryName()
    },
    credentials: getRequestCredentials(env.PAGE_BUILDER_AUTH_STRATEGY),
    okType: customType
  })
}

const customType = z.unknown().transform((val, ctx) => {
  const result = StaticCustomType.decode(val)
  if (result._tag === "Right") return result.right

  ctx.addIssue({
    code: z.ZodIssueCode.custom,
    message: "Invalid custom type."
  })

  return z.NEVER
})

export function useRepositoryTypes() {
  const repositoryTypes = useRequest(getRepositoryCustomTypes, [
    env.CUSTOM_TYPES_API_BASE_URL,
    getRepositoryName(),
    env.PAGE_BUILDER_AUTH_STRATEGY
  ])

  return repositoryTypes
}
